import { Metamodel } from '../base/model';
import { format } from 'app/shared/utils/string.util';

import { TabularTypeDataset } from './tabular-type.dataset';
import { IModel } from '../base/annotation';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sybase.datasetType,
    display: [format(stringResources.ModelName_DatasetTemplate, stringResources.Sybase_DisplayText),
            format(stringResources.ModelName_DatasetsTemplate, stringResources.Sybase_DisplayText)]
})
export class SybaseTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
